<script lang="ts">
  import { Button } from '$lib/components/ui/button';
  import DownloadIcon from '@lucide/svelte/icons/download';

  let {
    href = '/quick-search.zip',
    download = 'quick-search.zip',
    label = 'Télécharger quick-search.zip',
  }: {
    href?: string;
    download?: string;
    label?: string;
  } = $props();
</script>

<Button {href} {download}>
  <DownloadIcon data-icon="inline-start" />
  {label}
</Button>
